import type { InferOutput } from "valibot";
import { type Options, useMutation } from "../useMutation";
import { type CampaignInputSchema, CampaignOutputSchema } from "./schemaTypes";

export const useCampaignMutation = (options?: Options<InferOutput<CampaignOutputSchema>>) => {
  return useMutation<CampaignInputSchema, CampaignOutputSchema>("/api/campaign-set/", CampaignOutputSchema, options);
};
